export default __webpack_public_path__ + "static/media/logo_en.1071d37e.png";